import { csvParse } from 'd3-dsv';
import json from './json';
export default function csv(data, cfg) {
  var csvData = csvParse(data);
  return json(csvData, cfg);
}
//# sourceMappingURL=csv.js.map